// NOTE: This file is used by both the browser and NodeJS tooling code of this repo.
//       Please keep this file free of code tying it to either environment.

import { SemVer, coerce } from "semver";

export const coerceVersion = (depVersion: string, depName?: string): SemVer => {
  const coercedVersion = coerce(depVersion);
  if (!depVersion || !coercedVersion) {
    const source = depName ? `${depName}@${depVersion}` : depVersion;
    throw new Error(`Could not determine a valid version from "${source}"`);
  }
  return coercedVersion;
};
